import axios from 'axios'
import { axiosConfig } from '@/config/axiosConfig.js'

export const get_alert_message_ajax = async () => {
    try {
        const res = await axios.get('/get_alert_message/', axiosConfig)
        return res.data.data;
    } catch (e) {
        console.error(e);
    }
}
